import { Button, Select, Text } from '@nvision/ui';

import { Card } from '@/components/card';

import { useProjectsControls } from '../../../hooks';

import styles from './projects-controls.module.css';

export const ProjectsControls: React.FC = () => {
  const { changeSort, createProject, selectedSortOption, sortOptions } = useProjectsControls();

  return (
    <Card>
      <Card.Header>
        <Text size="sm" weight="semibold">
          Project Results
        </Text>
      </Card.Header>
      <Card.Main>
        <div className={styles.controls}>
          <div className={styles.leftSection}>
            <Select
              options={sortOptions}
              value={selectedSortOption}
              placeholder="Select"
              onSelectionChange={changeSort}
              className={styles.sortSelect}
              size="sm"
            />
          </div>

          <div className={styles.rightSection}>
            <Button size="sm" iconLeft="circle-plus" onClick={createProject} primary>
              Create Project
            </Button>
          </div>
        </div>
      </Card.Main>
    </Card>
  );
};
